module.exports = __webpack_public_path__ + "static/media/logo.addfb3a0.svg";